<template>
    <div>
        <b-modal
            id="add-country-popup"
            ref="modal"
            :title="titleHeading"
            size="sm"
            no-close-on-backdrop
            hide-footer
            modal-class="hide-footer"
            no-close-on-esc
            :hide-header-close="loading"
            @hidden="onHidden"
        >
            <b-form
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12 row-min-space">
                        <div class="row">
                            <div class="col-md-6">
                                <b-form-group
                                    id="input-group-1"
                                    label="Country Code"
                                    label-for="input-1"
                                >
                                    <b-form-input
                                        id="input-1"
                                        v-model="formData.code"
                                        v-validate="{
                                            required: true,
                                            min: 2,
                                            max: 4,
                                            regex: /^[a-zA-Z_ ]*$/,
                                        }"
                                        type="text"
                                        autocomplete="no"
                                        placeholder="Enter country code"
                                        name="country code"
                                        :class="{
                                            'is-invalid': errors.has(
                                                'country code'
                                            ),
                                        }"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group
                                    id="input-group-2"
                                    label="Dialling Code"
                                    label-for="input-2"
                                >
                                    <b-form-input
                                        id="input-2"
                                        v-model="formData.isdCode"
                                        v-validate="{
                                            min: 2,
                                            max: 4,
                                            required: true,
                                            regex: /^[\+\d]([0-9]*)$/,
                                        }"
                                        type="text"
                                        autocomplete="no"
                                        placeholder="Enter dialling code"
                                        name="dialling code"
                                        :class="{
                                            'is-invalid': errors.has(
                                                'dialling code'
                                            ),
                                        }"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-3"
                            label="Country Title"
                            label-for="country-title"
                        >
                            <b-form-input
                                id="country-title"
                                v-model="formData.title"
                                v-validate="{
                                    required: true,
                                }"
                                type="text"
                                autocomplete="no"
                                placeholder="Enter country title"
                                name="country title"
                                :class="{
                                    'is-invalid': errors.has('country title'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-4"
                            label="Rating"
                            label-for="nationality"
                        >
                            <b-form-select
                                v-model="formData.rating"
                                v-validate="{
                                    required: true,
                                }"
                                class="form-control"
                                :options="rating"
                                name="rating"
                                :class="{
                                    'is-invalid': errors.has('rating'),
                                }"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-5"
                            class="mb-0 kyc-status-radio overwrite-radio"
                            label="Is Sanction"
                            label-for="sanction"
                        >
                            <b-form-group>
                                <b-form-radio-group
                                    v-model="formData.isSanction"
                                    v-validate="{
                                        required: true,
                                    }"
                                    :options="boolVal"
                                    name="sanction"
                                    :class="{
                                        'is-invalid': errors.has('sanction'),
                                    }"
                                ></b-form-radio-group>
                            </b-form-group>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-6"
                            class="mb-0 kyc-status-radio overwrite-radio"
                            label="Tax ID"
                            label-for="tax-id"
                        >
                            <b-form-group>
                                <b-form-radio-group
                                    v-model="formData.taxIdRequired"
                                    v-validate="{
                                        required: true,
                                    }"
                                    :options="tax"
                                    name="taxId"
                                    :class="{
                                        'is-invalid': errors.has('taxId'),
                                    }"
                                ></b-form-radio-group>
                            </b-form-group>
                        </b-form-group>
                    </div>

                    <div v-show="formData.taxIdRequired" class="col-md-12">
                        <b-form-group
                            id="input-group-7"
                            class="mb-0 kyc-status-radio overwrite-radio"
                            label="Is Tax ID Mandatory"
                            label-for="id-mandatory"
                        >
                            <b-form-group>
                                <b-form-radio-group
                                    v-model="formData.isTaxIdMandatory"
                                    v-validate="{
                                        required: true,
                                    }"
                                    :options="boolVal"
                                    name="idMandatory"
                                    :class="{
                                        'is-invalid': errors.has('idMandatory'),
                                    }"
                                ></b-form-radio-group>
                            </b-form-group>
                        </b-form-group>
                    </div>
                    <div v-show="formData.taxIdRequired" class="col-md-12">
                        <b-form-group
                            id="input-group-8"
                            label="Tax ID Note"
                            label-for="tax-note"
                        >
                            <b-form-input
                                id="tax-note"
                                v-model="formData.taxIdNote"
                                v-validate="{
                                    max: 250,
                                }"
                                type="text"
                                autocomplete="off"
                                name="Tax Id Note"
                                :class="{
                                    'is-invalid': errors.has('Tax Id Note'),
                                }"
                                placeholder="Enter tax id note (optional)"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        :btn-label="buttonLabel"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        :disabled="loading"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'selectedItem', 'hidePopup']),
        titleHeading() {
            return this.selectedItem
                ? 'Modify Country of Residence Factor'
                : 'Add Country of Residence Factor'
        }, // End of title() method

        buttonLabel() {
            return this.selectedItem ? 'Update' : 'Create'
        },
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            boolVal: [
                { text: 'Yes', value: true },
                { text: 'No', value: false },
            ],
            tax: [
                { text: 'Required', value: true },
                { text: 'Not Required', value: false },
            ],
            rating: [
                { value: null, text: 'Select Rating' },
                { value: 'high', text: 'High Risk' },
                { value: 'medium', text: 'Medium Risk' },
                { value: 'low', text: 'Low Risk' },
            ],
            formData: this.initializeFormData(),
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        selectedItem(value) {
            if (value !== null && value !== undefined) {
                Object.assign(this.formData, value)
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        initializeFormData() {
            return {
                _id: null,
                code: '',
                isdCode: '',
                title: '',
                taxIdNote: '',
                rating: null,
                isSanction: false,
                taxIdRequired: false,
                isTaxIdMandatory: false,
            }
        }, // End of initializeFormData() method
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$store.commit('onSubmit', null)
            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
        /**
         * Handle when the modal is canceled
         *
         * @return {void}
         */
        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    await this.$store.dispatch('onSubmit', this.formData)
                } catch (error) {
                    // console.log(error, 'There is an error on submit')
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method
    }, // End of Component > watch
}
</script>
